<template>
  <div admin-footer>
    <div>
      <div class="wrapper">
        <p>{{ asset('address') }} <span class="mh-10">|</span> {{ asset('companyNo') }}</p>
        COPYRIGHT (C) 2018 {{ asset('name') }} KS 인증시스템. All RIGHT RESERVED
      </div>
    </div>
  </div>
</template>

<style lang="less">
  @import "../../../less/proj";

  [admin-footer] { background:#222; color:#999;
    .wrapper { .p(25,0);
      p { .fs(14,1.8); }
    }
  }
</style>

<script>
import { getScrollBody } from '../../../utils';

export default {
  name: 'Footer',
  methods: {
    goTop() {
      getScrollBody().animate({ scrollTop: 0 }, 300);
    },
    scroll() {
      // this.showGoTop = (getScrollBody().scrollTop() > window.innerHeight);
    },
  },
  data() {
    return {
      showGoTop: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
    this.scroll();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scroll);
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin/common/AppFooter.vue